import { APIModel } from '@shared/interfaces';

import { Language } from '@/organisations/models';

export class QuestionFieldOptions implements APIModel {
    id = -1;
    language: Language = Language.NL;
    text: string[] = [];
    values: string[] = [];
    sorted = false;

    deserialize(data: any) {
        this.id = data.id ?? -1;
        this.language = data.language ?? Language.NL;
        this.text = data.text ?? [];
        this.values = data.values ?? [];
        this.sorted = data.sorted ?? false;
        return this;
    }
}
